import { useId, useState, useMemo } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { breakpoints } from '@ui/css';
import { Tablist, Search, TabSection } from '@ui/kit';
import { HideFor, CollapsibleTransition } from '@utils/react';
import { wrapper, searchWrapper, contentWrapper, content, transitionDurationMs } from '../shared.tablist.style.js';
import { useComponentEntrySelector, componentEntryStore } from '../state.js';
import { useStudentEntries } from './hook.student-entries.js';
import { StudentEntriesTable } from './table.root.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { filterComponentEntry } from '../utils/filter.js';

const continueTabId = "continue-tab";
const finishedTabId = "finished-tab";
function StudentTablist() {
  const baseId = `student-tablist-${useId()}`;
  const filters = useComponentEntrySelector(state => state);
  const [selectedTabId, setSelectedTabId] = useState(continueTabId);
  const timespan = useComponentEntrySelector(state => state.filters.timespan);
  const rawEntries = useStudentEntries(timespan);
  const unfinishedEntries = useMemo(() => rawEntries.unfinishedEntries.filter(it => filterComponentEntry(filters, it)), [filters, rawEntries.unfinishedEntries]);
  const finishedEntries = useMemo(() => rawEntries.finishedEntries.filter(it => filterComponentEntry(filters, it)), [filters, rawEntries.finishedEntries]);
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    children: [/*#__PURE__*/jsx(Tablist, {
      baseId: baseId,
      label: "V\xE6lg sektion",
      tabs: [{
        id: continueTabId,
        title: `Fortsæt hvor du slap`
      }, {
        id: finishedTabId,
        title: `Færdige besvarelser`
      }],
      selectedTabId: selectedTabId,
      onTabClick: setSelectedTabId
    }), /*#__PURE__*/jsx(HideFor, {
      breakpoint: breakpoints.mobile,
      className: searchWrapper,
      children: /*#__PURE__*/jsx(Search, {
        placeholder: "S\xF8g i besvarelser",
        "aria-label": "S\xF8g i besvarelser",
        onQueryChange: newQuery => componentEntryStore.dispatch(componentEntryStore.actions.setQuery(newQuery)),
        compact: true,
        debounceMs: 350,
        theme: "local"
      })
    }), /*#__PURE__*/jsx("div", {
      className: contentWrapper,
      children: /*#__PURE__*/jsx(TransitionGroup, {
        component: null,
        children: /*#__PURE__*/jsx(CollapsibleTransition, {
          timeout: transitionDurationMs,
          classNames: content,
          swappable: true,
          axis: "vertical",
          children: ref => /*#__PURE__*/jsx("div", {
            ref: ref,
            className: content,
            children: /*#__PURE__*/jsx(TabSection, {
              baseId: baseId,
              selectedTabId: selectedTabId,
              children: selectedTabId === continueTabId ? /*#__PURE__*/jsx(StudentEntriesTable, {
                type: "unfinished",
                entries: unfinishedEntries
              }) : /*#__PURE__*/jsx(StudentEntriesTable, {
                type: "finished",
                entries: finishedEntries
              })
            })
          })
        }, `selected-tab-${selectedTabId}`)
      })
    })]
  });
}

export { StudentTablist };
//# sourceMappingURL=molecule.tablist.js.map
